<template>
  <div class="child-bg-image">
    <div class="bg-image-section" />
    <div class="content-section">
      <v-alert
        border="left"
        colored-border
        color="rgb(255, 55, 0)"
        elevation="1"
        dense
        class="mt-2 mb-2 py-2"
        :icon="false"
      >
        <div class="d-flex justify-space-between align-center">
          <div class="pr-2">
            <div class="font-weight-bold text-caption">
              Web App is Closing Soon
            </div>

            <div
              class="text-caption"
              style="line-height: 1.2"
            >
             Please note that the current app will stop working on Sunday, 25 May at 6:30 PM AEST. Kindly switch to the new Swift Checkin app before that time to avoid any interruption.
            </div>
          </div>

          <v-btn
            color="rgb(255, 55, 0)"
            dark
            outlined
            x-small
            height="26"
            class="px-2"
            @click="downloadApp"
          >
            Download
          </v-btn>
        </div>
      </v-alert>
      <home-page />
      <div
        v-if="userData.active"
        class="view-all-div"
      >
        <!-- <home-page-active-check-in /> -->
        <home-page-pending-request />
        <br>
        <br>
      </div>
    </div>
    <alert-dialog
      v-if="showTimezoneDialog"
      :title="'Timezone'"
      :message="'Your timezone has changed. Update now?'"
      @closed="showTimezoneDialog = false"
      @confirmed="changeTimezone"
    />
    <alert-dialog
      v-if="showTimesheetPopup"
      title="Missed Check-in Alert"
      :message="'Your previous timesheet is missing.'"
      cancel-button="Later"
      confirm-button="Go to timesheet"
      @confirmed="toTimesheets"
      @closed="closeTimesheetPopup"
    />
    <alert-dialog
      v-if="showPwaClosingPopup"
      title="Swift Check-In App"
      :message="`Please note that the current app will stop working on Sunday, 25 May at 6:30 PM AEST. Kindly switch to the new Swift Checkin app before that time to avoid any interruption.`"
      confirm-button="Download App"
      cancel-button="Later"
      :download-pop-up="true"
      @confirmed="downloadApp"
      @closed="closePwaPopup"
    />
  </div>
</template>

<script>
import { getTimeZone } from '../../../utils/timezone';
import HomePage from '../Components/HomePage.vue';
import HomePagePendingRequest from '../Components/HomePagePendingRequest.vue';
import AlertDialog from '../../components/AlertDialog.vue';

export default {
  name: 'Home',
  components: {
    HomePage,
    HomePagePendingRequest,
    AlertDialog,
  },

  data () {
    return {
      permissionStatus: Notification.permission,
      isPWA: false,
      showTimezoneDialog: false,
      showTimesheetPopup: false,
      showPwaClosingPopup: false,
    };
  },

  computed: {
    user () {
      return this.$store.getters.getUser;
    },
    shouldShowPwaPopup () {
      const today = new Date().toISOString().slice(0, 10);
      const lastShown = localStorage.getItem('pwa_closing_popup_last_shown');

      return lastShown !== today;
    },
    userDetails () {
      return this.$store.getters['userprofile/getUserDetails'];
    },
    userData () {
      return this.$store.getters.getSelectedOrganization;
    },

    timesheetAlert () {
      return this.$store.getters['alert/getTimesheetAlert'];
    },
    selectedOrganization () {
      return this.$store.getters.getSelectedOrganization;
    },
    orgSettings () {
      return this.$store.getters['organization/getOrganizationSettings'];
    },
    isMissedTimesheetPopUpEnabled () {
      return this.orgSettings.missed_previous_day_alert;
    },

    shouldShowTimesheetPopup () {
      if (this.timesheetAlert) return false;
      const today = new Date().toISOString().slice(0, 10);
      const lastShown = localStorage.getItem('timesheet_alert_last_shown');
      return lastShown !== today;
    },
  },
  async mounted () {
    this.isPWA = this.isPWAInstalled();
    await this.fetchOrgDetails();
    this.$store.dispatch('appusers/updateAppUserPlatform', {
      platform_type: this.isPWA ? 'app' : 'web',
    });
    await this.$store.dispatch('userprofile/fetchUserDetails');
    await this.checkTimezone();
  },

  methods: {
    isPWAInstalled () {
      return (
        window.matchMedia('(display-mode: standalone)').matches ||
        window.navigator.standalone === true
      );
    },
    async fetchOrgDetails () {
      await this.$store.dispatch(
        'organization/fetchOrganizationSettings',
        this.selectedOrganization,
      );
      if (!this.userData.timesheet_tracking) return;
      if (!this.isMissedTimesheetPopUpEnabled) return;

      if (
        this.shouldFetchTimesheetAlert() &&
        this.selectedOrganization.active
      ) {
        await this.checkTimesheetAlert();

        if (this.shouldShowTimesheetPopup) {
          this.showTimesheetPopup = true;
        }
      }
    },
    closePwaPopup () {
      const today = new Date().toISOString().slice(0, 10);

      localStorage.setItem('pwa_closing_popup_last_shown', today);

      this.showPwaClosingPopup = false;
    },

    async downloadApp () {
      const today = new Date().toISOString().slice(0, 10);

      localStorage.setItem('pwa_closing_popup_last_shown', today);

      this.showPwaClosingPopup = false;

      const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
      const isAndroid = /Android/.test(navigator.userAgent);
      await this.$store.dispatch('alert/clickDataAnalytics', {
        type: isIOS ? 'ios' : 'android',
      });

      if (isIOS) {
        window.location.href =
          'https://apps.apple.com/us/app/swift-checkin-construction-app/id6755225256';
      } else if (isAndroid) {
        window.location.href =
          'https://play.google.com/store/apps/details?id=com.swiftcheckin.app';
      } else {
        window.location.href =
          'https://play.google.com/store/apps/details?id=com.swiftcheckin.app';
      }
    },
    shouldFetchTimesheetAlert () {
      const today = new Date().toISOString().slice(0, 10);
      const lastShown = localStorage.getItem('timesheet_alert_last_shown');
      return lastShown !== today;
    },
    closeTimesheetPopup () {
      const today = new Date().toISOString().slice(0, 10);
      localStorage.setItem('timesheet_alert_last_shown', today);
      this.showTimesheetPopup = false;
    },
    toTimesheets () {
      const today = new Date().toISOString().slice(0, 10);
      localStorage.setItem('timesheet_alert_last_shown', today);
      this.$router.push('/timesheets');
    },

    async checkTimezone () {
      const timezone = getTimeZone();

      if (this.userDetails.timezone === null) {
        await this.$store.dispatch('userprofile/updateTimezone', {
          params: { timezone },
        });
      } else if (this.userDetails.timezone !== timezone) {
        this.showTimezoneDialog = true;
      } else {
        this.showTimezoneDialog = false;
      }
    },
    async changeTimezone () {
      const timezone = getTimeZone();
      await this.$store
        .dispatch('userprofile/updateTimezone', {
          params: {
            timezone: timezone,
          },
        })
        .then(() => {
          window.location.reload();
          // this.$router.push({ name: 'Logout' });
        });
    },
    async requestPermission () {
      if ('Notification' in window) {
        const permission = await Notification.requestPermission();
        this.permissionStatus = permission;
      } else {
        alert('Notifications are not supported in this browser.');
      }
    },
    showNotification () {
      if (this.permissionStatus === 'granted') {
        navigator.serviceWorker.getRegistration().then((reg) => {
          if (reg) {
            reg.showNotification('✅ Notification Test', {
              body: 'This is a working test notification!',
              icon: '',
            });
          } else {
            alert('❌ Service worker not registered.');
          }
        });
      } else {
        alert('🔒 Notification permission not granted.');
      }
    },
    async checkTimesheetAlert () {
      await this.$store.dispatch('alert/showTimesheetAlert', {
        externalId: this.selectedOrganization.organization.external_id,
      });
    },
  },
};
</script>
<style scoped>
.content-section {
  padding-top: 80px;
}
</style>
